import r from "../managers/braze-instance.js";
export function removeSubscription(e) {
  r.rr() && r.removeSubscription(e);
}
